const $ = jQuery.noConflict();

'use strict';
const megaMenu = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$megaMenuParent: $('.js-megamenu-parent'),
	$megaMenuWrap: $('.js-megamenu-wrap'),
	$megaMenu: $('.js-megamenu'),

	/** @description Initialize */
	init: function() {
		if ($('.js-hidden-megamenu').length) {
			$('.js-nav-icon').remove();
		}
		this.bindEvents();
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.appendMenu();
		$('.nturl').on('click', ()=>{
			setTimeout(()=>{
				window.location.reload();
			}, 400);
		});
	},

	appendMenu: function() {
		this.$megaMenuParent.append(this.$megaMenuWrap);
	},
};

export default megaMenu;
